import { useContext, useEffect, useId } from "react";
import type { EventNode, TypedEvent } from "@/shared/lib/componentHierarchy";
import type { InlinePlaybackEvent } from "@/shared/lib/inlinePlaybackMediator";
import {
  useComponentNode,
  useMediatorSnapshot,
} from "@/shared/ui/component-hierarchy/hooks";
import { InlinePlaybackContext } from "@/shared/ui/component-hierarchy/inlinePlaybackContext";

export interface InlineVideoPresentation {
  node: EventNode<TypedEvent>;
  playing: boolean;
  onPlay: () => void;
}

export function useInlineVideoPresenter(): InlineVideoPresentation {
  const playback = useContext(InlinePlaybackContext);
  if (!playback)
    throw new Error("Inline video presenters require ComponentRoot");
  const id = useId();
  const node = useComponentNode();
  const playing = useMediatorSnapshot(playback) === id;
  useEffect(
    () => (): void => {
      const event: InlinePlaybackEvent = { type: "media.inline.release", id };
      node.dispatch(event);
    },
    [node, id],
  );
  return {
    node,
    playing,
    onPlay(): void {
      const event: InlinePlaybackEvent = { type: "media.inline.play", id };
      node.dispatch(event);
    },
  };
}
